

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { MailCheck, Mail } from 'lucide-react';
import { EmailMetricsSection } from './metrics/EmailMetricsSection';
import { WeeklyEmailPreviewTab } from './preview/WeeklyEmailPreviewTab';

export function EmailTab() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Email Management</CardTitle>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="performance" className="w-full">
          <TabsList className="grid w-full grid-cols-2 gap-2 p-1.5 rounded-md">
            <TabsTrigger 
              value="performance" 
              className="px-4 py-2.5 flex items-center justify-center gap-1.5"
            >
              <MailCheck className="h-4 w-4" />
              <span>Email Performance</span>
            </TabsTrigger>
            <TabsTrigger 
              value="preview" 
              className="px-4 py-2.5 flex items-center justify-center gap-1.5"
            >
              <Mail className="h-4 w-4" />
              <span>Report Preview</span>
            </TabsTrigger>
          </TabsList>
          <TabsContent value="performance" className="mt-4">
            <EmailMetricsSection />
          </TabsContent>
          <TabsContent value="preview" className="mt-4">
            <WeeklyEmailPreviewTab />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
}
